import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@/components';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { useEffect, useState } from 'react';
import styles from './adjustable.module.less';
export const AdjustableInput = ({ className, value, min, max, disabled, onUpdate = noop, }) => {
    const [val, setVal] = useState('');
    useEffect(() => {
        setVal(value.toString());
    }, [value]);
    return (_jsxs("span", { className: classnames(styles.container, className), children: [_jsx(Icon, { className: classnames(styles.button, styles.decrease, {
                    [styles.disabled]: (min && value <= min) || disabled,
                }), type: "decrease", role: "button", onClick: () => {
                    if (min && value <= min)
                        return;
                    onUpdate(value - 1);
                } }), _jsx("input", { className: styles.input, type: "number", value: val, onChange: (evt) => {
                    setVal(evt.target.value);
                    if (evt.target.value) {
                        onUpdate(parseInt(evt.target.value));
                    }
                } }), _jsx(Icon, { className: classnames(styles.button, styles.increase, {
                    [styles.disabled]: (max && value >= max) || disabled,
                }), type: "increase", role: "button", onClick: () => {
                    if (max && value >= max)
                        return;
                    onUpdate(value + 1);
                } })] }));
};
